<template>
  <div class="calculator">
    <div
      class="calculator-show__btn"
      @click="changeModalShow"
    >
      Калькулятор
    </div>
    <transition>
      <div
        class="calculator-modal"
        v-show="modalShow"
      >
        <div class="calculator-modal__block">
          <div class="calculator-date">
            Дата принятия закона:
<!--            <span>{{ new Date(adoptionDate) | dateFormat('DD.MM.YYYY') }}</span>-->
            <div class="form-date ml-2">
              <v-menu
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="adoptionDate"
                    required
                    readonly
                    v-on="on"
                    outlined
                    rounded
                    dense
                  />
                </template>
                <v-date-picker
                  v-model="adoptionDate"
                  @input="getResultData"
                  no-title
                  first-day-of-week="1"
                />
              </v-menu>
            </div>
          </div>
          <div class="calculator-date">
            Введите кол-во месяцев для реализации:
            <div class="calculator-date__select">
              <v-select
                v-model="monthCount"
                :items="[1,2,3,4,5,6,7,8,9,10,11,12]"
                outlined
                rounded
                dense
              />
            </div>
          </div>
          <div class="calculator-date">
            Срок реализации:
            <span class="calculator-date__strong">{{ new Date(resultAdoptionDate) | dateFormat('DD.MM.YYYY') }}</span>
          </div>
          <div class="calculator-buttons">
            <div
              class="button save"
              @click="save"
            >
              Сохранить
            </div>
            <div
              class="button cancel"
              @click="changeModalShow"
            >
              Отмена
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
  import mixin from '@/plugins/mixin/mixin'
  import { dateFormat } from 'vue-filter-date-format'
  export default {
    name: "ImplementationPeriodCalculator",
    mixins: [mixin],
    props: {
      law: {
        type: Object,
        requried: true
      }
    },

    data () {
      return {
        modalShow: false,
        adoptionDate: '2023-02-28',
        monthCount: 2,
        resultAdoptionDate: null,
        showAdoptionDatePicker: false
      }
    },

    watch: {
      monthCount: {
        handler (val) {
          if (val) {
            this.getResultData()
          }
        }
      }
    },

    mounted () {
      this.getResultData();
      this.adoptionDate = this.law?.adoption_date?.trim().split('T')[0]
    },

    methods: {
      changeModalShow () {
        this.modalShow = !this.modalShow
      },

      getResultData () {
        // this.adoptionDate = this.law.adoption_date
        var newDate = new Date(this.adoptionDate);

        const currentDay = newDate.getDate()
        const beforeLastDay = this.daysInMonth(newDate.getFullYear(), newDate.getMonth())
        const afterLastDay  = this.daysInMonth(newDate.getFullYear(), newDate.getMonth() + this.monthCount)
        newDate.setMonth(newDate.getMonth() + this.monthCount);

        if ([28, 29, 30, 31].includes(currentDay)) {
          newDate.setDate(newDate.getDate() + (afterLastDay - beforeLastDay))
        }

        this.resultAdoptionDate = newDate
      },

      daysInMonth (year, month) {
        return new Date(year,month + 1, 0).getDate();
      },

      save () {
        var datestring = this.resultAdoptionDate.getFullYear() + "-" + ("0"+(this.resultAdoptionDate.getMonth()+1)).slice(-2) + "-" + ("0" + this.resultAdoptionDate.getDate()).slice(-2);
        this.$emit('save', datestring)
        this.changeModalShow()
      }
    }
  }
</script>
<style lang="scss">
  .calculator {
    &-buttons {
      display: flex;
      margin-top: 20px;
      justify-content: center;

      .button {
        padding: 5px 60px;
        cursor: pointer;
      }

      .save {
        background-color:#2096f3 ;
        color: #fff;
      }

      .cancel {
        border: 1px solid silver;
        margin-left: 20px;
      }
    }

    &-date {
      font-size: 24px;
      padding: 10px 0;
      display: flex;
      justify-content: center;

      &__select {
        margin-left: 10px;
        max-width: 140px;
        font-size: 24px;

        .v-input__slot {
          min-height: 38px;
          max-height: 38px;
          font-size: 24px;
          max-height: 100px;
        }
      }

      &__strong {
        color: rgba(0, 140, 208, 1);
        font-weight: 600;
      }
    }

    &-show__btn {
      margin-left: 20px;
      text-align: center;
      width: 142px;
      height: 32px;
      line-height: 32px;
      background: #8AA6C8;
      border-radius: 10px;
      color: #FFFFFF;
      cursor: pointer;
      transition: all 0.4s;

      &:hover {
        letter-spacing: 1px;
      }
    }

    &-modal {
      position: fixed;
      width: 100%;
      height: 100vh;
      left: 0;
      right: 0;
      top: 0;
      background-color: rgb(62,65,70, 0.5);
      z-index: 1000;
      display: flex;
      align-items: center;
      justify-content: center;

      &__block {
        background-color: #fff;
        padding: 40px 55px;
      }
    }
  }
</style>
